"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _useStyles = _interopRequireDefault(require("../../../helpers/useStyles"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _progress = require("@flomni/components/dist/components/progress");

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles["default"])(".c77e39b27{width:100%;position:absolute;left:0;top:0;z-index:100}.cd569f679{height:.3125rem!important}");
var styles = {
  loader: 'c77e39b27',
  line: 'cd569f679'
};

var ProgressLoader = function ProgressLoader(props) {
  var css = (0, _useStyles["default"])(styles);
  if (!props.show) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: css(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["loader"])))
  }, /*#__PURE__*/_react["default"].createElement(_progress.Progress, {
    classes: {
      root: css(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["line"])))
    }
  }));
};

ProgressLoader.propTypes = {
  show: _propTypes.bool.isRequired
};

var _default = /*#__PURE__*/(0, _react.memo)(ProgressLoader);

exports["default"] = _default;